import { AlcoholResult_OPTIONS } from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { StatFieldProps } from "../pages/VolunteerTestsList";
import { LatestRecord } from "./volunteertest.types";
import { validations } from "validations/FormValidations";

export const volunteerTestColumn: FormFieldConfig[] = [
  {
    name: "bac",
    label: "Blood Alcohol Concentration (BAC)",
    type: "number",
    placeholder: "Enter detected value",
    rules: validations.volunteer.bac,
    required: true
  },
  {
    name: "alcoholunit",
    label: "Unit",
    type: "select",
    options: [
      { label: "mg/dL", value: "mg/dL" },
      { label: "% BAC", value: "% BAC" }
    ],
    required: true
  },
  {
    name: "alcoholresult",
    label: "Test Result",
    type: "select",
    options: AlcoholResult_OPTIONS,
    required: true
  },
  {
    name: "indicatorlightcolor",
    label: "Indicator Light Color",
    placeholder: "Enter indicator light color",
    type: "text",
    required: true,
    rules: validations.volunteer.indicatorlightcolor
  },
]

export const cardStatFields = (latestRecord: LatestRecord): StatFieldProps[] => [
  { label: "Stage", value: latestRecord?.alcoholstage },
  { label: "BAC Value", value: latestRecord?.bac, highlight: true },
  { label: "Unit", value: latestRecord?.alcoholunit },
];


/* --------------------------------
 Test 
--------------------------------- */

export const VolunteerTestCard = [
  {
    key: "alcohol",
    name: "Alcohol Test",
    icon: "ri-goblet-line",
    color: "text-primary",
  },
];  